export default __webpack_public_path__ + "static/media/iso_cert.6b0032b1.jpg";